<template>
    <header class="uikit-header">
        <!-- <SvlpComponentNavAccesibilidad /> -->
      <div class="container mt-1">
          <b-navbar class="main-menu">
              <template #brand>
                  <b-navbar-item href="/">
                      <img src="/images/landing-sucursal-virtual/logo-cha.svg" alt="Logotipo de ChileAtiende, dos franjas de colores azul y roja con una estrella y dos personas" />
                  </b-navbar-item>
              </template>
              <template #end>
                  <b-navbar-item href="#" class="close-menu" title="Cerrar">
                      Cerrar<span class="close">×</span>
                  </b-navbar-item>

                  <b-navbar-dropdown class="sucursales" label="Puntos de atención presencial" title="Detalle de los puntos de atención presencial">
                      <b-navbar-item href="/ayuda/sucursales" title="Ver información sobre ubicación y horario de sucursales">Ubicación y horario de sucursales</b-navbar-item>
                      <!-- <b-navbar-item href="/agendamiento" title="Ver información sobre agenda tu hora de atención">Agenda tu hora de atención</b-navbar-item> -->
                      <b-navbar-item href="/ayuda/atencion-movil" title="Ver información sobre oficinas móviles">Oficinas móviles</b-navbar-item>
                  </b-navbar-dropdown>

                  <b-navbar-item href="/sucursalvirtual" class="videoatencion" title="Ir a la sucursal virtual">Video Atención</b-navbar-item>

                  <b-navbar-item href="/ayuda/atencion-telefonica" class="telefono" title="Ir al centro de ayuda">101</b-navbar-item>
                  
                  <b-navbar-dropdown class="redes" label="Redes sociales" title="Detalle de las redes sociales">
                      <b-navbar-item href="https://www.facebook.com/ChileAtiende" title="Ir al Facebook de ChileAtiende">Facebook</b-navbar-item>
                      <b-navbar-item href="https://www.instagram.com/chileatiende" title="Ir al Instagram de ChileAtiende">Instagram</b-navbar-item>
                      <b-navbar-item href="https://twitter.com/ChileAtiende" title="Ir al X de ChileAtiende">X</b-navbar-item>
                      <b-navbar-item href="https://www.youtube.com/user/ChileAtiende/featured" title="Ir al canal de Youtube de ChileAtiende">Youtube</b-navbar-item>
                  </b-navbar-dropdown>
                  
                  <b-navbar-item href="https://formulario.chileatiende.cl/FormularioCha/" class="contacto" title="Ir a página de contacto">Contacto</b-navbar-item>
              </template>
          </b-navbar>
      </div>
    </header>
</template>

<script>
import SvlpComponentNavAccesibilidad from "./SvlpComponentNavAccesibilidad.vue";
export default {
  components: {
    SvlpComponentNavAccesibilidad
  }
};
</script>
